import * as React from 'react';

function Footer(_ref) {
  var children = _ref.children;
  return React.createElement("tfoot", null, children);
}

export default Footer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/Footer/index.js
// module id = 1816
// module chunks = 1